import React, {Component} from 'react';
import {Col, Row, Button} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga';

//CSS
import '../../../assets/css/ProductoStandart.css';


//assets
import dobleProducto from '../../../assets/img/productos/dobleProducto2.png';
import portada from '../../../assets/img/productos/multiplex15.png';
import btnDescarga from '../../../assets/img/productos/btnDescarga.png';
import btnDescargaOsc from '../../../assets/img/productos/btnDescargaGrey.png';
import hr from '../../../assets/img/productos/hr.png';
import logo25 from '../../../assets/img/logo25prod.png';


//Import Components
import Galeria from '../../elementos/Galeria';
import SliderFinan from "../../elementos/SliderFinan";


//Import Imagenes Galeria
import foto1 from '../../../assets/img/galeria/mutliplex15/foto1.png';
import foto2 from '../../../assets/img/galeria/mutliplex15/foto2.png';
import foto3 from '../../../assets/img/galeria/mutliplex15/foto3.png';
import foto4 from '../../../assets/img/galeria/mutliplex15/foto4.png';

import valor1 from '../../../assets/img/valores/multiplex15/valor1.png';
import valor2 from '../../../assets/img/valores/multiplex15/valor2.png'

const photos = [
    {src: foto1, width: 4, height: 3},
    {src: foto2, width: 4, height: 3},
    {src: foto3, width: 4, height: 3},
    {src: foto4, width: 4, height: 3}
];

class Multiplex15 extends Component {

    componentDidMount() {
        document.title = "Multiplex 1.5 - Sensor Tecnología";
        window.scrollTo(0, 0);
    }

    realiceSuConsulta(){
        var data =  {
            content_category: 'clics',
            content_name: 'bt-realice-consulta'
        };
        ReactPixel.track( 'Lead', data );

        ReactGA.event({
            action:'consultar',
            category: 'clics',
            label: 'bt-realice-consulta'
        });
    }

    render() {
        return (
            <div>
                <section className="productos productos-std">
                    <div className="home-producto">
                        <Row>
                            <Col md={6}>
                                <div className="img-producto">
                                    <img className="img-responsive" src={portada} alt=""/>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="tit-producto">
                                    <h1>
                                        <span>{this.context.t('Multiplex 1.5')}</span>
                                        <img src={logo25} alt=""/>
                                        </h1>
                                    <img src={hr} alt=""/>
                                    <p>{this.context.t('Más confiabilidad, más flexibilidad y más operatividad')}</p>
                                    <p className="tit-dsc">{this.context.t('Panel electrónico para control de funciones de carrocería y chasis.')}</p>
                                    <p className="dsc">{this.context.t('El Multiplex 1.5 es derivado de la exitosa plataforma tecnológica TEVIS, creada por Sensor Tecnología en 2004.  El sistema contola y gestiona las funciones y actividades de una máquina compleja, y puede aplicarse en: ómnibus urbanos, interurbanos y de media distancia; minibuses; ambulancias y embarcaciones.')}
                                    </p>
                                    <br/><br/>
                                    <Col md={6} className="no-padding-left">
                                        <Link to="/contacto" onClick={() => this.realiceSuConsulta()}>
                                            <Button>{this.context.t('Realice su consulta')}</Button>
                                        </Link>
                                    </Col>
                                </div>

                            </Col>
                        </Row>
                    </div>
                    <div className="home-gallery">
                        <Galeria photos={photos}/>
                    </div>

                    <div className="productos-caracteristicas">
                        <div className="container-limit">
                            <Row>


                                <Col md={6}>
                                    <div className="caracteristicas-descripcion">
                                        <h3>{this.context.t('Tecnología de confianza')}</h3>
                                        <div className="red-line3"></div>
                                        <p className="sinBorde">
                                            {this.context.t('Esta tecnología, creada en 2004, pasó exitosamente por diversos mercados (agricultura, vial, minería y pecuaria) volviéndose más versátil y adaptable, incluyendo numerosas funcionalidades y propiedades ya pre establecidas.')}
                                        </p>
                                    </div>

                                </Col>
                                <Col md={6} style={{paddingTop: "70px"}}>
                                    <div className="img-graficos">
                                        <img className="img-responsive" src={valor1} alt=""/>
                                    </div>
                                </Col>
                            </Row>
                            <br/><br/><br/><br/>
                            <Row>
                                <Col md={6}>
                                    <div className="caracteristicas-descripcion" style={{marginTop: "60px"}}>
                                        <h3>{this.context.t('Flexibilidad')}</h3>
                                        <div className="red-line3"></div>

                                        <p className="sinBorde">
                                            {this.context.t('El sistema trabaja bajo un método centralizado, brindando diversos módulos de entradas/salidas disponibles de acuerdo a la necesidad de la máquina a controlar.\n' +
                                                'Entre sus características destacamos, el control de hasta 24 salidas, el frente a prueba de agua, y el teclado tipo membrana retroiluminado.')}
                                        </p>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="img-graficos">
                                        <img className="img-responsive" src={valor2} alt=""/>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>

                    <Row>
                        <div className="descargas">
                            <Row>
                                <Col md={12} className="bgGrey">
                                    <a target="_blank" href={process.env.PUBLIC_URL + "/archivos/multiplex15/Multiplex 1-5.pdf"}>
                                        <div className="btnDescarga" style={{paddingTop:"5%",paddingBottom:"5%"}}>
                                            <img src={btnDescargaOsc} alt=""/>
                                            <div className="dscDescarga" style={{color: "#676868"}}>
                                                <h3>{this.context.t('Catálogo')}</h3>
                                                <h5>{this.context.t('Multiplex 1.5')}</h5>
                                            </div>
                                        </div>
                                    </a>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                </section>

            </div>
        )
    }
}

export default Multiplex15;